<template>
    <footer class="site-footer">

        <!-- Top -->
        <div class="footer-top">
            <div class="container">
                <div class="row g-5">

                    <!-- Brand column -->
                    <div class="col-12 col-sm-6 col-lg-5">
                        <a href="#" class="footer-brand">
                            <img src="../assets/img/bantainapp-logo.png" alt="bantainapp" class="footer-logo">
                        </a>
                        <p class="footer-tagline">
                            Helping crypto investors grow on their own terms — low barriers, automated rewards, institutional-grade staking.
                        </p>
                        <div class="footer-contact-row">
                            <a href="mailto:support@bantainapp.com" class="footer-contact-chip">
                                <ion-icon name="mail-outline"></ion-icon>
                                support@bantainapp.com
                            </a>
                        </div>
                    </div>

                    <!-- Quick links -->
                    <div class="col-6 col-sm-6 col-lg-2">
                        <h4 class="footer-heading">Company</h4>
                        <ul class="footer-links">
                            <li><a href="#features">Features</a></li>
                            <li><a href="#service">How It Works</a></li>
                            <li><a href="#faq">FAQ</a></li>
                            <li><a href="#contact">Contact</a></li>
                        </ul>
                    </div>

                    <!-- Legal -->
                    <div class="col-6 col-sm-6 col-lg-2">
                        <h4 class="footer-heading">Legal</h4>
                        <ul class="footer-links">
                            <li>
                                <a href="#" data-toggle="modal" data-target="#termsModal">Terms of Use</a>
                            </li>
                            <li>
                                <a href="#" data-toggle="modal" data-target="#privacyModal">Privacy Policy</a>
                            </li>
                        </ul>
                    </div>

                    <!-- CTA column -->
                    <div class="col-12 col-sm-6 col-lg-2">
                        <h4 class="footer-heading">Get Started</h4>
                        <p class="footer-cta-text">
                            Ready to put your crypto to work?
                        </p>
                        <a href="/desktop" target="_self" class="btn footer-cta-btn">
                            <ion-icon name="wallet-outline"></ion-icon>
                            Open Wallet
                        </a>
                        <div class="footer-trust mt-3">
                            <ion-icon name="shield-checkmark-outline" class="footer-trust-icon"></ion-icon>
                            <span>Secure · Non-custodial · Always-on</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- Divider -->
        <div class="footer-divider"></div>

        <!-- Bottom bar -->
        <div class="footer-bottom">
            <div class="container">
                <div class="footer-bottom-inner">
                    <span class="footer-copy">
                        &copy; {{ year }} Bantain. All rights reserved.
                    </span>
                    <span class="footer-badge">
                        <ion-icon name="checkmark-circle-outline"></ion-icon>
                        Tested &amp; Trusted
                    </span>
                </div>
            </div>
        </div>

    </footer>
</template>

<script>
export default {
    name: 'footNav',
    computed: {
        year(){ return new Date().getFullYear(); }
    }
};
</script>

<style scoped>
.site-footer {
    background: #1A0F08;
    color: rgba(255,255,255,0.82);
}

/* Top */
.footer-top {
    padding: 72px 0 56px;
}

/* Brand */
.footer-brand {
    display: inline-block;
    margin-bottom: 20px;
}
.footer-logo {
    width: 140px;
    height: auto;
    display: block;
        filter: brightness(0) invert(1) !important;
    opacity: 0.92 !important;
}
.footer-tagline {
    font-size: 13px;
    line-height: 1.8;
    color: rgba(255,255,255,0.78);
    margin-bottom: 20px;
    max-width: 280px;
}
.footer-contact-row {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.footer-contact-chip {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 12px;
    color: rgb(255,255,255)!important;
    text-decoration: none;
    transition: color 0.2s;
}
.footer-contact-chip ion-icon {
    font-size: 14px;
    color: var(--theme-primary-500, #73614C);
    flex-shrink: 0;
}
.footer-contact-chip:hover {
    color: #fff;
}

/* Column headings */
.footer-heading {
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(255,255,255,0.9);
    margin-bottom: 20px;
}

/* Links */
.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.footer-links a {
    font-size: 13px;
    color: rgba(255,255,255);
    text-decoration: none;
    transition: color 0.2s;
}
.footer-links a:hover {
    color: var(--theme-primary-500, #73614C);
}

/* CTA column */
.footer-cta-text {
    font-size: 13px;
    color: rgba(255,255,255,0.78);
    margin-bottom: 16px;
    line-height: 1.6;
}
.footer-cta-btn {
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px !important;
    padding: 12px 22px !important;
    background: var(--theme-primary-500, #73614C) !important;
    color: #fff !important;
    font-size: 13px !important;
    font-weight: 700 !important;
    border-radius: 50px !important;
    text-decoration: none !important;
    border: none !important;
    box-shadow: none !important;
    transition: background 0.2s, box-shadow 0.2s, transform 0.15s;
}
.footer-cta-btn ion-icon {
    font-size: 16px;
}
.footer-cta-btn:hover,
.footer-cta-btn:focus,
.footer-cta-btn:active {
    background: var(--theme-primary-700, #2A1F13) !important;
    box-shadow: 0 6px 20px rgba(115,97,76,0.3) !important;
    transform: translateY(-1px);
    color: #fff !important;
    text-decoration: none !important;
}
.footer-trust {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: rgba(255,255,255,0.70);
}
.footer-trust-icon {
    font-size: 14px;
    color: var(--theme-primary-500, #73614C);
}

/* Divider */
.footer-divider {
    height: 1px;
    background: rgba(255,255,255,0.06);
    margin: 0 24px;
}

/* Bottom bar */
.footer-bottom {
    padding: 20px 0;
}
.footer-bottom-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
}
.footer-copy {
    font-size: 12px;
    color: rgba(255,255,255,0.65);
}
.footer-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 11px;
    font-weight: 600;
    color: var(--theme-primary-500, #73614C);
    background: rgba(115,97,76,0.15);
    border: 1px solid rgba(115,97,76,0.25);
    padding: 4px 12px;
    border-radius: 50px;
}
.footer-badge ion-icon {
    font-size: 13px;
}
</style>
